import { useEffect } from 'react';
const WIDGET_ID = '6a8201c20d8ddea77baa9f4f';
const LOADER_SRC = 'https://widgets.leadconnectorhq.com/loader.js';
const RESOURCES_URL = 'https://widgets.leadconnectorhq.com/chat-widget/loader.js';

/**
 * Injects the GoHighLevel (LeadConnector) chat widget loader.
 * Rendered from React because the production HTML shell is generated by the
 * host and does not include custom <script> tags from index.html.
 */
const GHLChatWidget = () => {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Avoid double-injection on remounts / route changes
    if (document.querySelector(`script[data-widget-id="${WIDGET_ID}"]`)) {
      return;
    }
    const script = document.createElement('script');
    script.src = LOADER_SRC;
    script.async = true;
    script.setAttribute('data-resources-url', RESOURCES_URL);
    script.setAttribute('data-widget-id', WIDGET_ID);
    script.setAttribute('data-source', 'WEB_USER');
    script.onload = () => {
      console.log('✅ GHL chat widget cargado');
    };
    script.onerror = () => {
      console.error('❌ Error cargando el widget de GHL');
    };
    document.body.appendChild(script);
  }, []);
  return null;
};
export default GHLChatWidget;